import { Moment } from 'moment';

export enum WorkOrderMigrationDateFilterEnum {
  ENTRY = 'ENTRY',
  LEAVE = 'LEAVE',
  CLOSING = 'CLOSING',
  AUTHORIZATION = 'AUTHORIZATION',
}

export enum WorkOrderMigrationStatusFilterEnum {
  OPEN = 'OPEN',
  AUTHORIZED = 'AUTHORIZED',
  CLOSED = 'CLOSED',
  CANCELED = 'CANCELED',
}

export const WorkOrderMigrationDateFilterOption = [
  {
    value: WorkOrderMigrationDateFilterEnum.AUTHORIZATION,
    label: 'Autorização',
  },
  {
    value: WorkOrderMigrationDateFilterEnum.CLOSING,
    label: 'Fechamento',
  },
  {
    value: WorkOrderMigrationDateFilterEnum.ENTRY,
    label: 'Entrada',
  },
  {
    value: WorkOrderMigrationDateFilterEnum.LEAVE,
    label: 'Entrega',
  },
];

export const WorkOrderMigrationStatusFilterOption = [
  {
    value: WorkOrderMigrationStatusFilterEnum.AUTHORIZED,
    label: 'Autorizado',
  },
  {
    value: WorkOrderMigrationStatusFilterEnum.CANCELED,
    label: 'Cancelado',
  },
  {
    value: WorkOrderMigrationStatusFilterEnum.CLOSED,
    label: 'Fechado',
  },
  {
    value: WorkOrderMigrationStatusFilterEnum.OPEN,
    label: 'Aberto',
  },
];

export interface WorkOrderMigrationRequest {
  companyIds?: number[];
  dateFilter?: WorkOrderMigrationDateFilterEnum;
  endDate?: string;
  format?: string;
  licensePlate?: string;
  startDate?: string;
  statusFilter?: WorkOrderMigrationStatusFilterEnum;
}

export interface WorkOrderMigrationForm
  extends Omit<WorkOrderMigrationRequest, 'startDate' | 'endDate'> {
  selectCpfCnpjWatch: boolean;
  startDate: Moment;
  endDate: Moment;
}
